module.exports = __webpack_public_path__ + "static/media/trash_new_black.00f779e0.svg";